import { ReactNode } from 'react';

import { Flex } from 'src/components/Flex';
import { PageHeader, PageHeaderVariant } from 'src/layouts/MainLayout/PageHeader';

export interface PageContentProps {
    heading?: string;
    subHeading?: string;
    callToActions?: ReactNode;
    children: ReactNode;
    headerVariant?: PageHeaderVariant;
}

/**
 * @description This component should be used as the parent wrapper of a page (first child component of the MainLayout's children)
 * @param PageContentProps
 * @returns optional PageHeader if heading is passed and children of type ReactNode
 */
export const PageContent = ({
    heading,
    subHeading,
    children,
    callToActions,
    headerVariant,
}: PageContentProps) => {
    return (
        <Flex flexDirection="column" gap="24px">
            {heading && (
                <PageHeader
                    heading={heading}
                    subHeading={subHeading}
                    callToActions={callToActions}
                    variant={headerVariant}
                />
            )}
            {children}
        </Flex>
    );
};
